import BaseController from "confinus_ui/base_controller";

export default class AssigneeController extends BaseController {
  public static targets = ["form"];

  declare private readonly formTarget: HTMLFormElement;

  public submitForm() {
    this.formTarget.submit();
  }
}
